module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/issue-2/ar/img/high-growth-culture-300x300.9d46fd39.jpg";